import React, { Component } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { host, url } from '../../../config/common';
import Loader from '../../utils/loader';
import TokenExpireHandler from '../../utils/tokenExpireHandler';

export default class PrivacyPolicy extends Component {
  constructor(props){
    super(props)
    this.state = {
      privacyPolicy: "",
      showloader: false
    }
  }
  componentDidMount() {
    this.getPrivacyPolicy()
  }

  async getPrivacyPolicy () {
    try {
      this.setState({showloader: true})
      let fetchedData = await axios({
        method: 'get',
        headers: {'x-access-token': JSON.parse(localStorage.getItem('user'))?.token ? JSON.parse(localStorage.getItem('user')).token : ""},
        url: `${host}${url.getPrivacyPolicy}`,
      });
      if(fetchedData.status == 401){
        localStorage.removeItem("user")
        return this.props.navigate("/")
      }
      this.setState({showloader: false})
      if (fetchedData.data) {
        this.setState({privacyPolicy: fetchedData.data.result.data})
      }
    } catch (e) {
      console.log("error", e);
      TokenExpireHandler(this.props.navigate, e)
    }
  }

  async savePrivacyPolicy () {
    try {
      this.setState({showloader: true})
      let dataToSave ={privacyPolicy: this.state.privacyPolicy}
      let fetchedData = await axios({  
        method: 'post',
        headers: {'x-access-token': JSON.parse(localStorage.getItem('user'))?.token ? JSON.parse(localStorage.getItem('user')).token : ""},
        url: `${host}${url.privacyPolicy}`,
        data: dataToSave
      });
      if(fetchedData.status == 401){
        localStorage.removeItem("user")
        return this.props.navigate("/")
      }
      this.setState({showloader: false})
      this.props.alert.show("Saved Succesfully.", {type: 'success'})
    } catch (e) {
      console.log("error", e);
      TokenExpireHandler(this.props.navigate, e)
    }
  }
  render() {
    return (
      <div>
        <Loader show={this.state.showloader}/>
        <h2>Privacy Policy</h2>
        <CKEditor
          editor={ClassicEditor}
          config={{
            toolbar: {
              items: [
                'heading',
                '|',
                'bold',
                'italic',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'insertTable',
                '|',
                'undo',
                'redo',
                'link'
              ]
            },
          }}
          data={this.state.privacyPolicy}
          onChange={(event, editor) => {
            const data = editor.getData();
            this.setState({privacyPolicy: data})
          }}
        />
        <Button style={{marginTop: "2%"}} onClick={this.savePrivacyPolicy.bind(this)}>Save Privacy Policy</Button>
      </div>
    );
  }
}
